import { Component, OnInit } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountService } from 'src/app/core/services/account.service';
import { AdoptChildAccountRequest } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';

@Component({
  selector: 'app-adopt-child-account',
  templateUrl: './adopt-child-account.component.html',
  styleUrls: ['./adopt-child-account.component.scss']
})
export class AdoptChildAccountComponent implements OnInit {
  userForm: FormGroup;
  email: string;
  get f() { return this.userForm.controls; }
  constructor(
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private toastService: HotToastService,
  ) { }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      email: ['', Validators.required],
    });
  }

  onSubmit() {
    const request: AdoptChildAccountRequest = {
      email: this.userForm.controls.email.value
    };
    this.accountService.adoptChildAccount(request).subscribe(() => {
      this.toastService.success("An account link request email has been sent to " + this.userForm.controls.email.value
        + ". Please be sure to notify the account user that they must confirm and agree through the email request in order to complete your request.");
    },
      (error: HttpErrorResponse) => {
        if (error.status !== 401) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          if (errorMessage?.reasons) {
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
          else {
            this.toastService.warning("Link request failed");
          }
        }
      });
  }
}
